import Vue from 'vue';
import VueRouter from 'vue-router';
import App from './App.vue';
import VeeValidate from "vee-validate";
import Buefy from "buefy";
import "buefy/dist/buefy.css";
import "./assets/app.scss";
import "@mdi/font/css/materialdesignicons.min.css";
import HelloWorld from './components/HelloWorld.vue';

Vue.use(VueRouter);
Vue.use(Buefy);
Vue.use(VeeValidate, { events: '' });
Vue.config.productionTip = false;

/* eslint-disable no-console */

Vue.prototype.$apiUrl = "https://intra-api.swiss-support.net";
//Vue.prototype.$apiUrl = "http://localhost:58795";

Vue.filter("formatDatetoLocaleString", function (value: Date, locale: string) {
	if (value) {
		return value.toLocaleDateString(locale);
	}
});

const routes = [
	//{ path: '/bla', component: HelloWorld },
]

const router = new VueRouter({
	routes // short for `routes: routes`
})

new Vue({
	render: h => h(App),
	router
}).$mount('#app')

